import React from 'react';

import ClassesList from '@modules/classes/components/ClassesList';

const ClassesDirectory: React.FC = () => {
  return <ClassesList headerTitle="Diretório de Turmas" btnText="Criar Turma" pathToReturn="/minhas-turmas" pathRedirect="/diretorio/turmas/criar" />;
};

export default ClassesDirectory;
